import Api from '@api/multiStore'
import { ACCOUNT_MANAGE_PATH, SHOP_PRODUCTS_PATH } from '@constant'
import { getSessionMerchantInfo, isUltimate } from '@merchant-backend/util'
import { getProTitle } from '@util'
import { Modal } from 'hljd'
import { action, observable, runInAction } from 'mobx'
import React from 'react'
import { hashHistory } from 'react-router'
class Store {
  @action
  onCancel = () => {
    this.modalIf.isShow = false
  }
  @observable
  modalIf = {
    type: '',
    isShow: false,
    btn1: '',
    btn2: '',
    content: ''
  }

  @observable status = 0
  @action
  judgeStatus = async () => {
    let { data } = await Api.get_status()
    runInAction(() => {
      this.status = data.status
    })
  }
  @action
  upgradePro = async () => {
    let obj = getSessionMerchantInfo()
    let that = this
    const title = getProTitle()
    if (!isUltimate() && obj.is_adv != 1) {
      that.modalIf = {
        type: 2,
        isShow: true,
        btn1: '关闭',
        btn2: `了解${title}`,
        content: `您尚未开通${title}，暂时无法使用此功能！`
      }
      return
    }
    let { success, data = {} } = await Api.canUpgrade()
    if (success && data.can_upgrade == 1) {
      Modal.confirm({
        title: '升级提示',
        content:
          '升级成功后，当前账号将变为管理员账号，此门店将获得一组新的账号密码，方便您进行多门店登录管理。',
        onOk() {
          hashHistory.push(
            `${ACCOUNT_MANAGE_PATH}/upgrade?status=${that.status}`
          )
        },
        onCancel() {},
        cancelText: '下次再说',
        okText: '确认升级',
        iconType: 'info-circle'
      })
    } else {
      Modal.confirm({
        title: '升级失败',
        content: (
          <p>
            您暂未开通<span style={{ color: '#508cee' }}>{title}</span>
            ，无法升级多门店系统
          </p>
        ),
        onOk() {
          hashHistory.push(SHOP_PRODUCTS_PATH)
        },
        onCancel() {},
        cancelText: '取消',
        okText: `了解${title}`,
        iconType: 'exclamation-circle'
      })
    }
  }
}
export default new Store()
